import { render, staticRenderFns } from "./AdminCommunityActionsMenu.vue?vue&type=template&id=36ad28d2"
import script from "./AdminCommunityActionsMenu.vue?vue&type=script&lang=js"
export * from "./AdminCommunityActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports